import { Box, Grid, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import useSWR from 'swr';
import _getTickerInfo from '../../../../../../pages/api/_getTickerInfo';
import _getTickerAllNewsSummary from '../../../../../../pages/api/_getTickerAllNewsSummary';

const Item = styled(Paper)(({ theme }) => ({
  '& .MuiTableContainer-root::-webkit-scrollbar': {
    width: '8px',
    height: '5px',
  },
  '& .MuiTableContainer-root': {
    scrollbarWidth: 'thin',
  },
  '& .MuiTableContainer-root::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgb(176 176 177)',
    borderRadius: '6px',
    border: '1px solid rgba(224, 224, 224, 1)',
  },
  '& .MuiTableContainer-root::-webkit-scrollbar-track': {
    background: 'rgba(224, 224, 224, 1)',
    // borderRadius: '5px',
  },
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  height: '100%',
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    background: '#fbfbfc',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(1, 2),
    borderRadius: '7px 7px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .table-note': {
    padding: '4px 6px',
    fontSize: '.875rem',
    color: theme.palette.text.very_light_desc,
    fontStyle: 'italic',
    textAlign: 'left',
    background: '#fff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  }
}));

const AllNewsSummary = ({ info }) => {
  const { data, error, isLoading } = useSWR(
    ["api/_getTickerAllNewsSummary", info?.ticker, ""],
    _getTickerAllNewsSummary,
    {
      refreshInterval: 12 * 3600000,
      revalidateOnFocus: false,
      keepPreviousData: true,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        if (error.status === 404) return;
        // if (key === 'api/_getTickerAllNewsSummary') return;
        if (retryCount >= 10) return;
        setTimeout(() => revalidate({ retryCount }), 5000);
      }
    });

  const { getTickerAllNewsSummary } = data || {};
  const aiSummary = getTickerAllNewsSummary && getTickerAllNewsSummary.length > 0
    ? getTickerAllNewsSummary.find(d => d.ticker === info?.ticker)
    : null;
  const updatedAt = aiSummary && aiSummary?.updated_at ? (aiSummary?.updated_at?.match(/^\d{4}-\d{2}-\d{2}/)?.[0] ?? aiSummary?.updated_at) : null
  const renderSummary = (summaryWithSource) => {
    if (!summaryWithSource) return null;

    // Updated regex to match various source formats
    const regex = /\(Sources?:([^)]+)\)/g;
    const linkRegex = /([^,]+?)(?:,?\s*(?:-\s*)?)(https?:\/\/[^\s,)]+)/g;

    const modifiedText = summaryWithSource.replace(regex, (match, sourcesContent) => {
      const convertedSources = sourcesContent.replace(linkRegex, (_, name, url) => {
        const cleanName = name ? name.replace(/[,\s-]+$/, '').trim() : '';
        const linkText = cleanName && cleanName !== ' ' ? cleanName : url;
        return ` <a href="${url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
      });
      return `<span style="font-size: .76rem;">(Source${sourcesContent.includes(',') || sourcesContent.includes('http') ? 's' : ''}: ${convertedSources})</span>`;
    });
    return modifiedText;
  };

  return (
    <>
      {getTickerAllNewsSummary && getTickerAllNewsSummary.length > 0 && aiSummary?.positive_summary && aiSummary?.positive_summary !== "" &&
        <Grid size={{ md: 6, xs: 12 }}>
          <Item className="s-card fin-stmt">
            <Box sx={{
              borderRadius: '7px 7px 0 0', borderBottom: '1px solid #eae9ee', borderColor: '#eae9ee', padding: '0 8px 0 8px', verticalAlign: 'middle', background: '#fbfbfc', fontSize: '.875rem',
              '& .option-title': {
                fontSize: '.7rem', fontWeight: '500 !important', color: '#222 !important'
              }, display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'
            }}>
              <Typography component="h4" className="option-titlex" itemProp="name"
                sx={{
                  fontSize: '.875rem !important',
                  color: '#009900 !important', fontWeight: '600',
                }}>
                The Good News
              </Typography>
              <Typography component="body2" sx={{ fontSize: '.7rem', }}>Last Updated: {updatedAt}</Typography>
            </Box>
            <Box className="THREECOLSUM" sx={{ fontSize: '.87rem', px: 1, py: 0.5, '& a': { fontSize: '.76rem', color: '#174c86', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }, color: '#222' }} dangerouslySetInnerHTML={{ __html: renderSummary(aiSummary?.positive_summary) }} />
          </Item>
        </Grid>}
      {getTickerAllNewsSummary && getTickerAllNewsSummary.length > 0 && aiSummary?.negative_summary && aiSummary?.negative_summary !== "" &&
        <Grid size={{ md: 6, xs: 12 }}>
          <Item className="s-}card fin-stmt" >
            <Box sx={{
              borderRadius: '7px 7px 0 0', borderBottom: '1px solid #eae9ee', borderColor: '#eae9ee', padding: '0 8px 0 8px', verticalAlign: 'middle', background: '#fbfbfc', fontSize: '.875rem',
              '& .option-title': {
                fontSize: '.7rem', fontWeight: '500 !important', color: '#222 !important'
              }, display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'
            }}>
              <Typography component="h4" className="option-titlex" itemProp="name"
                sx={{
                  fontSize: '.875rem !important',
                  color: '#990000 !important', fontWeight: '600',
                }}>
                The Bad News
              </Typography>
              <Typography component="body2" sx={{ fontSize: '.7rem', }}>Last Updated: {updatedAt}</Typography>
            </Box>
            <Box className="THREECOLSUM" sx={{ fontSize: '.87rem', px: 1, py: 0.5, '& a': { fontSize: '.76rem', color: '#174c86', textDecoration: 'none' }, '& a:hover': { textDecoration: 'underline' }, color: '#222' }} dangerouslySetInnerHTML={{ __html: renderSummary(aiSummary?.negative_summary) }} />
          </Item>
        </Grid>}
      {getTickerAllNewsSummary && getTickerAllNewsSummary.length > 0 &&
        <Grid size={{ md: 12, xs: 12 }}>
          <Typography component="caption" sx={{ display: "block", textAlign: "left", m: '0 4px 4px 4px', fontStyle: 'italic', color: '#555', fontSize: '.7rem', }}>
            Disclaimer: This information is generated using our AI model (beta) and may contain inaccuracies. Please verify the information from multiple sources.
          </Typography>
        </Grid>}
    </>)
};

export default React.memo(AllNewsSummary)
